<template>
  <div class="detail-character-recommended">
    <IndexPc class="sm:w-full w-[1200px]" v-bind="props" />
  </div>
</template>
<script lang="ts" setup>
import type { Character } from '~/api/interface/character';
import IndexPc from './index-pc.vue';
interface CommonScenariosProps {
  digitalHumanList?: Character[];
}

const props = defineProps<CommonScenariosProps>();
</script>
<style lang="scss" scoped>
.detail-character-recommended {
  @apply flex-col items-center py-[160px];
  border-top: 1px solid var(--x-back-4);
  @media (max-width: 680px) {
    padding: 16px;
    margin-top: 50px;
    border-top: none;
  }
}
.common-race {
  @media (max-width: 680px) {
    width: vw(339);
  }
}
</style>
